import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const sizeMap = {
    large: tokens.fontSizes.medium,
    medium: tokens.fontSizes.small,
    small: tokens.fontSizes.xsmall,
};
const chapeauStaticStyle = css({
    fontWeight: tokens.fontWeights.bold,
    letterSpacing: tokens.letterSpacing.relaxed,
    lineHeight: tokens.lineHeights.default,
    textTransform: 'uppercase',
});
export function chapeauStyle({ inverted, size }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        chapeauStaticStyle,
        css({
            // NOTE: Small inconsistency in inverted vs themed colorings, until `inverted` is removed in v6 and component updated
            color: inverted ? tokens.colors.pink : theme.text.main,
            fontSize: sizeMap[size],
        }),
    ];
}
